import * as React from "react";
import './WelcomeHeader.scss';

export const WelcomeHeader: React.FunctionComponent<{}> = () => {

    return (
        <>
            <div className="col-12 welcome__header">
                <div className="card-header">
                    <h1>Välkommen till Libretto</h1>
                </div>
                <div className="card-footer">På denna sida hittar du nyheter, notiser och FAQ</div>
            </div>            
        </>
    )
}